export interface IInvoiceModel {
    SubscirptionID: string;
    ID: string;
    PlanItemName: string;
    TotalAmount: number;
    PaidAmount: number;
    TaxAmount: number;
    PaidDateTime: Date;
}


export enum PaymentStatus {
    AWAITING,
    SUCCESS,
    FAILED
}

export const mapChargebeeInvoice = (invoice: any): IInvoiceModel => {
    return {
        ID: invoice.id,
        SubscirptionID: invoice.subscription_id,
        PlanItemName: invoice.line_items.length ? invoice.line_items.map(x => x.quantity > 1 ? `${x.description} x${x.quantity}` : x.description).join(", ") : "--",
        TotalAmount: invoice.total,
        PaidAmount: invoice.amount_paid || invoice.amount_due,
        TaxAmount: invoice.tax,
        PaidDateTime: invoice.paid_at ? new Date(invoice.paid_at.toString().length === 10 ? invoice.paid_at * 1000 : invoice.paid_at) : new Date(invoice.generated_at.toString().length === 10 ? invoice.generated_at * 1000 : invoice.generated_at)
    } as IInvoiceModel
}
export interface IEstimateInvoiceModel {
    DueAmount: number;
    Subtotal: number;
    RenewalAmount: number;
    RenewalDateTime?: Date;
    TaxRatio: number;
    TaxAmount: number;
    TaxDescription: string;
    LineItems: ILineItem[];
}
export interface ILineItem {
    Description: string;
    TaxRate: number;
    TaxAmount: number;
    Subtotal: number;
    Total: number
}

export const mapChargebeeEstimateInvoice = (estimate: any, isOneTimeCharge: boolean): IEstimateInvoiceModel => {
    let invoice_estimate = estimate.invoice_estimate ? estimate.invoice_estimate : estimate.next_invoice_estimate;
    let taxes = invoice_estimate?.line_item_taxes?.filter((x: any) => x.tax_rate > 0) || [];
    return isOneTimeCharge ?
        {
            DueAmount: invoice_estimate.total / 100,
            Subtotal: invoice_estimate.sub_total / 100,
            RenewalAmount: estimate.amount_due,
            TaxAmount: (taxes.reduce((p: number, c: any) => p + c.tax_amount, 0) || 0) / 100,
            TaxRatio: Number(((taxes.reduce((p: number, c: any) => p + c.tax_rate, 0) || 0) / invoice_estimate.line_items.length).toFixed(2)),
            TaxDescription: invoice_estimate.taxes.map((x: any) => x.description).join("\n"),
            LineItems: invoice_estimate.line_items.map(mapLineItem) || []
        } as IEstimateInvoiceModel
        : {
            DueAmount: invoice_estimate.total / 100,
            Subtotal: invoice_estimate.sub_total / 100,
            RenewalAmount: estimate.amount_due,
            TaxAmount: (taxes.reduce((p: number, c: any) => p + c.tax_amount, 0) || 0) / 100,
            TaxRatio: Number(((taxes.reduce((p: number, c: any) => p + c.tax_rate, 0) || 0) / invoice_estimate.line_items.length).toFixed(2)),
            TaxDescription: invoice_estimate.taxes.map((x: any) => x.description).join("\n"),
            RenewalDateTime: new Date(estimate.subscription_estimate?.next_billing_at.toString().length === 10 ? estimate.subscription_estimate?.next_billing_at * 1000 : estimate.subscription_estimate?.next_billing_at),
            LineItems: invoice_estimate.line_items.map(mapLineItem) || []
        } as IEstimateInvoiceModel;
}

export const mapLineItem = (line_item: any) => {
    return {
        Subtotal: line_item.amount,
        Description: line_item.description,
        TaxAmount: line_item.tax_amount,
        TaxRate: line_item.tax_rate,
        Total: line_item.amount + line_item.tax_amount
    } as ILineItem
}